import { SVG, IconProps } from "../SVG";
import React from "react";

export const SvgGrid = ({ color = "#13126C", strokeWidth = "2", ...props }: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M10 3H3v7h7V3ZM21 3h-7v7h7V3ZM21 14h-7v7h7v-7ZM10 14H3v7h7v-7Z"
        />
    </SVG>
);
SvgGrid.displayName = "SvgGrid";
